// extracted by mini-css-extract-plugin
export default {"innerWrapper":"kz-z","tooltipWrapper":"lz-z","icon":"mz-z","tooltip":"nz-z","content":"oz-z"};